export const getTagsWithPlatformTag = (tags?: string[]) => {
	const defaultTags = ['atlaskit'];
	if (!tags) {
		return defaultTags;
	}
	return defaultTags.concat(tags);
};
